import type { Persona, PersonaPronouns } from '@/types/domain'

interface ConversationMacroContext {
  persona?: Pick<Persona, 'persona_name'> & Partial<Pick<Persona, 'pronouns'>> | null
}

type ConversationMacro = 'user' | 'sub' | 'obj' | 'poss' | 'poss_p' | 'ref'

const CONVERSATION_MACRO_PATTERN = /\{\{\s*(user|sub|obj|poss_p|poss|ref)\s*\}\}/g

const PRONOUN_MACROS: Record<PersonaPronouns, Record<Exclude<ConversationMacro, 'user'>, string>> = {
  'she/her': {
    sub: 'she',
    obj: 'her',
    poss: 'her',
    poss_p: 'hers',
    ref: 'herself',
  },
  'they/them': {
    sub: 'they',
    obj: 'them',
    poss: 'their',
    poss_p: 'theirs',
    ref: 'themselves',
  },
  'he/him': {
    sub: 'he',
    obj: 'him',
    poss: 'his',
    poss_p: 'his',
    ref: 'himself',
  },
}

export function renderConversationMacros(
  text: string | null | undefined,
  { persona }: ConversationMacroContext = {},
): string {
  if (!text) return ''

  const replacements: Partial<Record<ConversationMacro, string>> = {}
  if (persona?.persona_name) replacements.user = persona.persona_name
  if (persona?.pronouns && persona.pronouns in PRONOUN_MACROS) {
    Object.assign(replacements, PRONOUN_MACROS[persona.pronouns])
  }

  return text.replace(
    CONVERSATION_MACRO_PATTERN,
    (original, macro: ConversationMacro) => replacements[macro] ?? original,
  )
}
